import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import {forceDownload, filePreview} from "@/common/documentFunctions";
import {formatDate} from "../common/formatting";
import {
  GET_PUBLICATION_SUBFOLDERS,
  GET_PUBLICATION_CATEGORIES,
  GET_ALL_PUBLICATION_CATEGORIES,
  SET_SUBSCRIPTION_FOLDER,
  GET_RECENT_PUBLICATIONS,
  GET_SUBCAT_PUBLICATIONS,
  CLEAR_PUBLICATIONS,
  DOWNLOAD_PUBLICATION,
  PREVIEW_PUBLICATION,
  DOWNLOAD_BULK_PUBLICATION
} from "./actions.type";

const PublicationModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    folderId:null,
    recentPublications: [],
    rootFolders: [],
    subFolders: [],
    subscriptions: [],
    latestSubscriptions: [],
    publication: [],
    documents: []
  },
  mutations:{
    clearPublications(state) {
      state.documents = [];
    },
    setSubscription(state,subscriptions){
      state.subscriptions = subscriptions;
    },
    setRecentPublications(state, publications) {
      let transformed = [];
      transformed = publications.map(publication => {
          return {
            'name': {"value": publication.name},
            'dateUpdated': {"value": formatDate(publication.updated_at)},
            'actions': [{"link": publication.id}]
          }
        });
      state.recentPublications = transformed;
    },
    setPublicationCategoriesRoot(state, categories) {
      state.rootFolders = categories;
    },
    setPublicationCategoriesSub(state, categories) {
      state.subFolders = categories;
    },
    setSubCategoryPublications(state, documents) {
      state.documents = documents;
    },
    setPublication(state,folderId){
      state.folderId = folderId;
      state.publication = state.subscriptions.filter(el => el.id === folderId)[0].publication;
    }
  },
  getters: {

  },
  actions: {
    async [DOWNLOAD_PUBLICATION] (context, payload) {
      return new Promise((resolve,reject)=>{
        let url = "publications/" + payload.id;
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve();
          })
          .catch( response => {
            console.log(response);
          });
      });
    },
    async [PREVIEW_PUBLICATION] (context, payload) {
      let url = "publications/" + payload.id;
      return new Promise((resolve,reject)=>{
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then( response => {
            resolve(filePreview(response));
          })
          .catch( response => {
            reject("Unable to download file. Please contact the System Administrator.");
          });
      });
    },
    async [DOWNLOAD_BULK_PUBLICATION] (context, ids) {
      if (ids.length == 0) {
        return false;
      }

      let url = 'publications/bulk';
      var formData = new FormData();
      for (let id of ids) {
        formData.append('ids[]', id);
      }
      return new Promise((resolve, reject) => {
        ApiService.request({
          'method': 'post',
          'url': url,
          'data': formData,
          responseType: 'blob'
        }).then(response => {
              forceDownload(response);
              resolve({'message':'File downloaded!'});
        }).catch(error => {
          reject(error);
        });
      });
    },
    async [GET_RECENT_PUBLICATIONS] (context, payload) {
      let res = {};
      let url = "/publications";
      await ApiService.get(url)
        .then(response => {
          res = response.data.data;
          context.commit('setRecentPublications', res);
        })
        .catch(error => {
          //TODO
          console.log(error);
        });
      return res;
    },
    async [GET_ALL_PUBLICATION_CATEGORIES] (context, payload) {
      let res = {};
      let url = "/categories";
      res = await ApiService.get(url)
        .then(response => {
          return response;
        })
        .catch(error => {
          //TODO
          console.log(error);
        });
      return res.data;
    },
    async [GET_PUBLICATION_CATEGORIES] (context, payload) {
      let res = {};
      let url = "/categories/parent";
      await ApiService.get(url)
        .then(response => {
          res = response.data.data;
          context.commit('setPublicationCategoriesRoot', res);
        })
        .catch(error => {
          //TODO
          console.log(error);
        });
    },
    async [GET_PUBLICATION_SUBFOLDERS] (context, payload) {
      let category = payload;
      let res = {};
      let url = `/categories/${category}`;
      await ApiService.get(url)
        .then(response => {
          res = response.data.data;
          context.commit('setPublicationCategoriesSub', res);
        })
        .catch(error => {
          //TODO
          console.log(error);
        });
    },
    async [GET_SUBCAT_PUBLICATIONS] (context, payload) {
      let category = payload;
      let res = {};
      let url = `/publications/category/${category}`;
      await ApiService.get(url)
        .then(response => {
          res = response.data;
          context.commit('setSubCategoryPublications', res);
        })
        .catch(error => {
          //TODO
          console.log(error);
        });
    },
    [SET_SUBSCRIPTION_FOLDER](context,payload){
      context.commit('setPublication',payload);
    },
    [CLEAR_PUBLICATIONS] (context) {
      context.commit('clearPublications');
    }
  }
};
export default PublicationModule;
